export default function PrismicEndpoints() {
  return {
    root: "https://ew-portfolio.cdn.prismic.io/api/v2"
  }
}

